/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { indexesCreate } from "../../funcs/indexesCreate.js";
import * as components from "../../models/components/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: components.CreateIndexRequest$inboundSchema,
};

export const tool$indexesCreate: ToolDefinition<typeof args> = {
  name: "indexes-create",
  description: `Create an index

Create a new index to organize and store documents or items from integrations.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await indexesCreate(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
